export default __webpack_public_path__ + "static/phone-canada-btn-c6486e3d73fc15195e46d48c7c24962f.png";